import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import MuiTypography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { traducciones } from '../../views/pages/operator/ProductionRecordsPage';
import { useTheme } from '@mui/material/styles';

const TimeCycleLineChart = ({ chartData, height = 350, showLabel = true, isDarkMode = false, showToolbar = true }) => {
    const theme = useTheme();
    if (!chartData) return null;

    const fontFamily = `Inter, sans-serif`;
    const averages = chartData?.averages ?? [];

    const hasValidData = averages.some((val) => val !== null && val !== undefined);

    const series = hasValidData
        ? [
              {
                  name: 'Tiempo Ciclo (Promedio)',
                  data: averages
              }
          ]
        : [];
    const GREEN = isDarkMode ? '#FFFFFF' : theme.palette.primary.main;
    const LINE_COLOR = theme.palette.secondary.dark;
    const AXIS_COLOR = isDarkMode ? '#FFFFFF' : theme.palette.grey[700];

    const options = {
        chart: {
            type: 'line',
            height: height,
            locales: [traducciones],
            defaultLocale: 'es',
            animations: {
                enabled: false
            },
            fontFamily,
            toolbar: {
                show: showToolbar,
                export: {
                    csv: {
                        filename: `Gráfico promedios de ciclos de tiempo por hora.`,
                        headerCategory: 'Horas'
                    },
                    svg: { filename: `Gráfico promedios de ciclos de tiempo por hora.` },
                    png: { filename: `Gráfico promedios de ciclos de tiempo por hora.` }
                }
            }
        },
        noData: {
            text: 'No hay datos disponibles',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: AXIS_COLOR,
                fontSize: '16px',
                fontFamily: fontFamily
            }
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        xaxis: {
            categories: chartData?.categories ?? [],
            tickAmount: 8,
            labels: {
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            axisBorder: {
                show: true,
                color: AXIS_COLOR
            },
            axisTicks: {
                show: true,
                color: AXIS_COLOR
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            title: {
                text: 'Promedio de tiempo de ciclo',
                style: {
                    fontFamily,
                    color: AXIS_COLOR,
                    fontSize: '16px'
                }
            }
        },
        legend: {
            position: 'bottom',
            fontSize: '12vpx',
            fontFamily,
            labels: {
                colors: AXIS_COLOR
            }
        },
        grid: {
            borderColor: '#eeeeee',
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } }
        },
        tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            style: {
                fontFamily
            },
            y: {
                formatter: (v) => {
                    if (v === null || v === undefined) return 'Sin producción';
                    else {
                        return v;
                    }
                }
            }
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => {
                if (val === null || val === undefined || val === 0) return '';
                return val;
            },
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
                fontFamily
            }
        },
        colors: [LINE_COLOR]
    };

    return (
        <Box>
            {showLabel && (
                <MuiTypography variant="h5" sx={{ fontWeight: 400, textAlign: 'center', color: 'gray' }}>
                    Promedio tiempo de ciclo por hora.
                </MuiTypography>
            )}
            <Chart options={options} series={series} height={height} type={'line'} />
        </Box>
    );
};

export default TimeCycleLineChart;
